export default __webpack_public_path__ + "static/media/blueprint-mono.790c3897.svg";